import { Component, Inject, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { fromEvent, Observable } from 'rxjs';
import { Touchterminalpayment } from 'src/app/services/api/touchterminalpayment/touchterminalpayment.service';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { UserTouchTerminalComponent } from '../user-touch-terminal/user-touch-terminal.component';


@Component({
  selector: 'app-payment-touch-terminal',
  templateUrl: './payment-touch-terminal.component.html',
  styleUrls: ['./payment-touch-terminal.component.css']
})
export class PaymentTouchTerminalComponent implements OnInit {
  eventHeight: Observable<any> = fromEvent(window, "resize");
  innerHeight: number = window.innerHeight;


  loader: boolean = false;
  data: any;
  paymentIntent: any;
  paymentIntentHandled: any

  progressInterval: any = null;
  timeProgressInterval = 3000;
  timeMaxWaitResp = 90;
  mess_loader = [
    { status: -1, mess: "KO", color: "red" },
    { status: 0, mess: "NOTPROCESSED", color: "grey" },
    { status: 1, mess: "RECEIVEDTPE", color: "blue" },
    { status: 2, mess: "OK", color: "green" },
  ];
  statusMessage: any;
  $error: any = false;
  nowPayment:any

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<PaymentTouchTerminalComponent>,
    private tools: ToolsService,
    private Touchterminalpayment: Touchterminalpayment,
    public media: MediaObserver,
    public dialog: MatDialog
  ) {

    this.data = data;
   

  }

  ngOnInit() {
    this.messageLoader(0);
    this.onWindowResize();
    this.nowPayment=null;
    this.paymentTouchTerminal();


  }




  ngOnDestroy(): void {
    this.stopIntervalProgressPayment();
  }


  /**
  * @description set in base pay_intent
  */

  paymentTouchTerminal() {

    this.$error = false;
   
    this.Touchterminalpayment.setTouchTerminalPayIntent(this.data).subscribe(payintent => {
  
  
    


      if (payintent.code < 0) {

        this.$error = true;

        setTimeout(() => {
          this.$error = false;
          this.closeDial()
        }, 5000);


      }
      else {

        this.nowPayment= moment();
        this.paymentIntent = payintent;
        this.startIntervalProgressPayment();


      }
    })

  }


  /**
     * @description get status  in base pay_intent
     */

  getProgressPayment() {

    let tosend = {
      webshop_id: this.data.webshop_id,
      pay_intent_id: this.paymentIntent.id
    };


    this.Touchterminalpayment.getTouchTerminalPayIntent(tosend).subscribe((pi: any) => {
    
 
   
      this.paymentIntentHandled = pi.pay_intent;
      this.messageLoader(this.paymentIntentHandled.status);
   

      let time_Exceeded = this.checkTimeExceeded();
    
      //test
      // this.paymentIntentHandled.status=2;

      if (this.paymentIntentHandled.status > 1 || time_Exceeded || this.paymentIntentHandled.status < 0) {
     
        this.stopIntervalProgressPayment();
        //message ok ou ko
        this.finalStatusBeforeClose();

      }

      //code 0 ok
      // payIntent:{id: 62, id_user: 24844, amount: 2.1, id_device: 6, status: 0, date: "2023-10-10 15:41:38",date_handled:null}

      // STATUS : 0 : non traité, 1 : reçu par le tpe, 2 : OK, -1 : KO

    });
  }

  messageLoader(status?: any) {

    this.statusMessage = this.mess_loader.find((value: any) => (value.status == status))
  }


  /**
     * @description  check is Time not Exceeded
     *  CALCUL LA DIFFERENCE ENTRE LA DATE ET NOW ET SI SUPERIEUR 2MIN parex
     */

  checkTimeExceeded() {
    let result = false;
 
    let startTimeold = moment(this.paymentIntentHandled.date);

    let startTime = this.nowPayment;

    let now = moment();
    let endTime = now.diff(startTime, 'seconds');
  
    if (endTime > this.timeMaxWaitResp && this.paymentIntentHandled.status < 2) {
      result = true;
    }
    return result;
  }

  /**
     * @description to do before Close
     */

  finalStatusBeforeClose() {
   
   
    setTimeout(() => {
      this.closeDial(this.paymentIntentHandled);
    }, 4000);
  }


  /**
     * @description start interval
     */

  startIntervalProgressPayment() {
    this.progressInterval = setInterval(() => {
      this.getProgressPayment();
    }, this.timeProgressInterval);
  }
  /**
     * @description stop interval
     */
  stopIntervalProgressPayment() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
  }



  /**
   * @description WindowResize
   */


  onWindowResize() {
    this.eventHeight.subscribe(event => {
      this.innerHeight = event.currentTarget.innerHeight;

    });
  }


  /**
    * @description closeDial
    */

  closeDial(data?: any): void {

    //statut // error
    this.dialogRef.close(data);

  }
  /**
  * @description dialog user control
  *@param info  
  *
  */

  openUsercontrol(): void {


    const myConf = new MatDialogConfig();

    myConf.disableClose = true;



    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%")
      : (myConf.width = "80%", myConf.height = "80%");
    const myDial = this.dialog.open(UserTouchTerminalComponent, myConf);

    myDial.afterClosed().subscribe((result) => {

      if (result) {
        let close = {
          code: 10
        }
        this.closeDial(close);

      }

      // this.tools.setOnPopState(true);

    });



  }


}





